

// OTHER SIDE
export function otherSide(side) {
  if (side === 'A') {
    return 'B';
  }
  else {
    return 'A';
  }
}

// SIDE COLOR
export function sideColor(side) {
  if (side === 'A') {
    return '赤';
  }
  else {
    return '青';
  }
}

// BORDER COLOR
export function borderColor(side) {
  if (side === 'A') {
    return 'borderColorA';
  }
  else {
    return 'borderColorB';
  }
}

// GET SELECT STATUS TYPE
export function getSelectStatusType(state) {
  if (state.duel.selectStatus.mode === 'magic') {
    return state.duel.castMagics[state.duel.selectStatus.magicIndex].route[state.duel.selectStatus.routeIndex].type;
  }
  else { // monster
    return 'neutral';
  }
}

// GET ROUTE
export function getRoute(state) {
  if (state.duel.selectStatus.mode === 'magic') {
    return state.duel.castMagics[state.duel.selectStatus.magicIndex].route[state.duel.selectStatus.routeIndex];
  }
  else { // monster
    return null;
  }
}

// MAGIC NARRATION
export function magicNarration(state, magics, initiative, monsterAssets) {
  let text = '';
  let monsterName = {};

  if (monsterAssets === undefined) {
    return text;
  }

  // -- 同キャラ対決のとき名前に色を付ける。
  if (monsterAssets.A === monsterAssets.B) {
    monsterName.A = state.registeredCard[monsterAssets.A]?.name + '(' + sideColor('A') + ')';
    monsterName.B = state.registeredCard[monsterAssets.B]?.name + '(' + sideColor('B') + ')';
  }
  else {
    monsterName.A = state.registeredCard[monsterAssets.A]?.name;
    monsterName.B = state.registeredCard[monsterAssets.B]?.name;
  }

  for (const side of [initiative, otherSide(initiative)]) {
    const magic = magics?.[side]?.[0];

    if (magic !== undefined) {
      text += monsterName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';
      // text += state.duel.basicInformation.duelistUserName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';

      if (magic.status === 'canceled') {
        text += 'しかし打ち消された。\n';
      }
    }
  }

  if (text !== '') {
    text += '\n';
  }

  return text;
}

// RECOVER TEXT FIELD
export function recoverTextField(state, dispatch, {
  monsters,
  magics,
  initiative,
  liveText,
  field,
  straightManText,
}) {
  // 魔法ナレーション

  let text = '';
  let monsterName = {};

  // -- 同キャラ対決のとき名前に色を付ける。
  if (monsters.A === monsters.B) {
    monsterName.A = state.registeredCard[monsters.A].name + '(' + sideColor('A') + ')';
    monsterName.B = state.registeredCard[monsters.B].name + '(' + sideColor('B') + ')';
  }
  else {
    monsterName.A = state.registeredCard[monsters.A].name;
    monsterName.B = state.registeredCard[monsters.B].name;
  }

  let duelistInOrder;

  if (initiative === 'A' || initiative === 'B') {
    duelistInOrder = [initiative, otherSide(initiative)];
  }
  else { // coinToss, undefined
    duelistInOrder = ['A', 'B'];
  }

  for (const side of duelistInOrder) {
    const magic = magics[side][0];

    if (magic !== undefined) {
      text += monsterName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';

      if (magic.status === 'canceled') {
        text += 'しかし打ち消された。\n';
      }
    }
  }

  // ライブテキスト

  if (text !== '') {
    text += '\n';
  }

  text += liveText;

  // フィールドの状況

  text += '\n<<フィールドの状況>>\n';
  text += field;

  // つっこみ

  if (straightManText !== undefined) {
    text += '\n<<つっこみ>>\n';
    text += straightManText;
  }

  dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: text});
  return text;
}

// GET CARD STATUS
export function getCardStatus(state, side, index) {
  let cardStatus;

  if (state.duel.result !== undefined && side !== undefined && side !== null && index !== undefined && index !== null) {
    cardStatus = state.duel.result[state.duel.result.length - 1]?.cards[side][index].status;
  }

  return cardStatus;
}

// GET CARD STATUS TMP
export function getCardStatusTmp(state, side, index) {
  let cardStatusTmp;

  if (state.duel.cardStatusTmp !== undefined && side !== undefined && side !== null && index !== undefined && index !== null) {
    const status = state.duel.cardStatusTmp[side]?.[index]?.status;

    if (status !== undefined) {
      cardStatusTmp = status;
    }
    else {
      cardStatusTmp = 'available'
    }
  }

  return cardStatusTmp;
}
